import { render } from "./ProductImportFiles.vue?vue&type=template&id=97f9024c"
import script from "./ProductImportFiles.vue?vue&type=script&lang=js"
export * from "./ProductImportFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__